import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'automationTemplate/list';

export function useAutomationTemplatesQuery({
	status,
	forAnyTrigger,
	industry,
	enabled = true,
	impersonationContext,
}: {
	status?: Api.TemplateStatus;
	forAnyTrigger?: boolean;
	industry?: Api.Industry;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();

	const queryParams: Record<string, string | boolean> = {};
	if (status !== undefined) {
		queryParams.status = status;
	}
	if (forAnyTrigger !== undefined) {
		queryParams.forAnyTrigger = forAnyTrigger;
	}
	if (industry !== undefined) {
		queryParams.industry = industry;
	}

	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationTemplate[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'automationTemplate',
					queryParams: Object.keys(queryParams).length > 0 ? queryParams : undefined,
					impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [
			BASE_QUERY_KEY,
			status,
			forAnyTrigger,
			industry,
			impersonationContext?.account?.id,
			impersonationContext?.user?.id,
		],
	});
}

export function invalidateAllAutomationTemplatesQueries() {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
